export default __webpack_public_path__ + "static/media/flip-page.8532e32b.wav";